const state = {
  activePauses: {
    voice: '',
    whatsapp: '',
  },
  scheduledPauses: {
    chat: null,
    voice: null,
    whatsapp: null,
  },
  dialogControl: {
    opened: false,
    type: 'general',
  },
  pauseAlerted: [],
  pauses: [],
};

export default state;
